import { SportsEvent } from 'schema-dts'
import { MatchClientModel } from '@sport1/types/sportData'
import { LabelProps, TagProps } from '@sport1/types/web'
import getTeamSportsEventByMatch from '@/components/LinkedData/getTeamSportsEventByMatch'
import getSportIdentifier from '@/utils/match/getSportIdentifier'

const map: {
    [sportIdentifier: string]:
        | ((m: MatchClientModel, tag?: TagProps | LabelProps) => SportsEvent)
        | undefined
} = {
    american_football: getTeamSportsEventByMatch,
    basketball: getTeamSportsEventByMatch,
    handball: getTeamSportsEventByMatch,
    icehockey: getTeamSportsEventByMatch,
    soccer: getTeamSportsEventByMatch,
    indoor_volleyball: getTeamSportsEventByMatch,

    // todo: add support for darts when we can show darts matches
    // todo: add support for tennis when we can show tennis matches
}

const convert = (
    match: MatchClientModel,
    tag?: TagProps | LabelProps,
    defaultSportIdentifier?: string
): SportsEvent | null => {
    const sportIdentifier = getSportIdentifier(match) || defaultSportIdentifier
    if (!sportIdentifier) {
        return null
    }
    const convertToSportEvent = map[sportIdentifier]
    if (!convertToSportEvent) {
        return null
    }
    return convertToSportEvent(match, tag)
}

export default function getSportsEventsByMatches({
    matches,
    tag,
    sportIdentifier,
}: {
    matches: MatchClientModel[] | MatchClientModel[][]
    tag?: TagProps | LabelProps
    sportIdentifier?: string
}): SportsEvent[] {
    if ('undefined' === typeof window) {
        return []
    }

    return matches
        .flat()
        .map(match => convert(match, tag, sportIdentifier))
        .filter(Boolean) as SportsEvent[]
}
